import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Clock } from 'lucide-react';

export const ServerTimeCard = ({ serverTime }) => {
  return (
    <Card className="mb-6 border-indigo-100/50">
      <CardHeader className="pb-2">
        <CardTitle className="text-sm flex items-center gap-2">
          <Clock className="w-4 h-4" /> Waktu Server
        </CardTitle>
      </CardHeader>
      <CardContent>
        <p className="text-2xl font-mono font-bold text-indigo-950">
          {serverTime?.toLocaleTimeString('id-ID')}
        </p>
        <p className="text-sm text-gray-500">
          {serverTime?.toLocaleDateString('id-ID', {
            weekday: 'long', day: 'numeric', month: 'long', year: 'numeric'
          })}
        </p>
      </CardContent>
    </Card>
  );
};
